var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5524 3.71296C8.82743 1.70587 9.465 0.702323 10.3824 0.741752C11.2998 0.781204 11.8895 1.83749 13.069 3.95009L13.374 4.49662C13.7092 5.09695 13.8768 5.39714 14.1441 5.60192C14.4116 5.80672 14.7486 5.89296 15.4224 6.06542L16.036 6.22245C18.4075 6.82941 19.5932 7.13289 19.8569 7.99802C20.1206 8.86316 19.2876 9.71703 17.6217 11.4247L17.1906 11.8665C16.7171 12.3518 16.4805 12.5945 16.3694 12.9024C16.2583 13.2104 16.2854 13.5489 16.3395 14.2258L16.3889 14.8422C16.5794 17.2244 16.6747 18.4155 15.9203 18.9107C15.1658 19.406 14.0613 18.8774 11.8522 17.8202L11.2807 17.5467C10.653 17.2463 10.3392 17.0961 10.0031 17.0816C9.66695 17.0671 9.34682 17.1902 8.70635 17.436L8.12325 17.6599C5.86959 18.5252 4.74275 18.9579 4.01281 18.3989C3.28288 17.8397 3.43316 16.6592 3.73384 14.2982L3.81165 13.6873C3.89718 13.0164 3.9399 12.6809 3.84325 12.364C3.74665 12.0471 3.52167 11.7846 3.07171 11.2596L2.66207 10.7816C1.07863 8.93429 0.286919 8.0106 0.590219 7.16983C0.893508 6.32905 2.09095 6.12802 4.48583 5.72596L5.10543 5.62194C5.78601 5.5077 6.12629 5.45058 6.40264 5.26916C6.67899 5.08773 6.86014 4.80256 7.22245 4.2322L7.5524 3.71296Z",
    fill: "#F0B826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.788eafcf13112874e3cd4923ee4027e9.svg";
export { ForwardRef as ReactComponent };